/* eslint-disable indent */
import { Box } from '@mui/material';
import React from 'react';
import { StandardEnum } from '../../../lib/helpers/apollo';
import { Button } from '../../../blocks/Button';
import styles from './MuiStepperButtonRow.module.scss';

export type MuiStepperButtonRowProps<T extends StandardEnum<string>> = {
	steps: T;
	activeStep: number;
	loading?: boolean;
	onNext?: React.MouseEventHandler<HTMLButtonElement>;
	onBack?: React.MouseEventHandler<HTMLButtonElement>;
};

const MuiStepperButtonRow = <T extends StandardEnum<string>>( {
	steps,
	activeStep,
	loading,
	onNext,
	onBack,
}: MuiStepperButtonRowProps<T> ) => (
	<Box className={ styles.buttonRow }>
		{ activeStep === 0 ? null : (
			<Button loading={ loading } onClick={ onBack } data-cy='stepper-back'>
				Back
			</Button>
		) }
		{ onNext ? (
			<>
				<Box />
				<Button loading={ loading } onClick={ onNext } data-cy='stepper-next'>
					{ activeStep === Object.keys( steps ).length - 1 ? <>Done</> : <>Next</> }
				</Button>
			</>
		) : null }
	</Box>
);

export default MuiStepperButtonRow;
